<template>
  <v-text-field
      outlined
      v-model="text"
      hide-details="hideDetails"
      :label="label"
  prepend-inner-icon="mdi-magnify"
  :clearable="clearable"/>
</template>

<script>
export default {
  name: 'SearchField',

  props: {
    value: {
      required: true,
    },
    label: {
      type: String,
    },
    clearable: {
      type: Boolean,
      default: true,
    },
    hideDetails:{},
  },
  data(){
    return {
      debounce: false,
    };
  },

  computed: {
    text: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);

      },
    },
  },
  watch: {
    value: function () {
      if (!this.debounce) {
        setTimeout(() => {
          this.debounce = false;
          this.$emit('change');
        }, 500);
      }
      this.debounce = true;

    },
  },
};
</script>

<style scoped>

</style>
